export default [
    {
        id: 1,
        name: 'all'
    },
    {
        id: 2,
        name: 'records'
    },
    {
        id: 3,
        name: 'person',
        isFiles: true
    },
    {
        id: 4,
        name: 'creative-work',
        isFiles: true
    },
    {
        id: 5,
        name: 'journal',
        isFiles: true
    },
    {
        id: 6,
        name: 'event',
        isFiles: true
    },
    {
        id: 7,
        name: 'institution',
        isFiles: true
    },
    {
        id: 8,
        name: 'series',
        isFilesOnly: true,
    },
];



// WEBPACK FOOTER //
// ./src/scripts/SearchOptions.js